import React from 'react'
import { useDispatch } from 'react-redux'
import { TextField, Button, Typography } from '@material-ui/core'
import { Formik, FormikErrors, FormikProps } from 'formik'
import { ButtonGrid } from '../../components'
import { locale } from '../../locale'
import { createUser } from '../../state/Firebase/operations'
import { createUserEnd } from '../../state/SystemCache/actions'

const toj = JSON.stringify

type Props = {
  handleCancel: () => void
  handleSubmit: (
    email: string,
    password: string,
    setErrors: (errors: FormikErrors<Fields>) => void,
  ) => void
}

type Fields = {
  email: string
  password: string
}

function CreateUserForm(props: Props) {
  const fields: Fields = {
    email: '',
    password: '',
  }

  return (
    <div>
      <Formik
        initialValues={fields}
        validate={(values) => {
          const errors: Partial<Fields> = {}

          if (!values.email) {
            errors.email = '必須です。'
          }
          if (!values.password) {
            errors.password = '必須です。'
          } else if (values.password.length < 8) {
            errors.password = '8文字以上にしてください。'
          }
          return errors
        }}
        onSubmit={(values: Fields, { setErrors }) => {
          props.handleSubmit(values.email, values.password, setErrors)
        }}
        render={({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          setFieldTouched,
        }: FormikProps<Fields>) => {
          const change = (name, e) => {
            e.persist()
            handleChange(e)
            setFieldTouched(name, true, false)
          }

          return (
            <form onSubmit={handleSubmit}>
              <Typography variant="h6">{locale.clientEntity}の追加</Typography>
              <TextField
                id="email"
                name="email"
                type="email"
                autoComplete="off"
                error={touched.email && Boolean(errors.email)}
                label="メールアドレス"
                helperText={touched.email ? errors.email : ''}
                value={values.email}
                onChange={change.bind(null, 'email')}
                fullWidth
                required
              />
              <Typography variant="caption" color="error">
                ※メールアドレスは変更することは出来ません。
              </Typography>
              <TextField
                id="password"
                name="password"
                type="text"
                autoComplete="off"
                error={touched.password && Boolean(errors.password)}
                label="パスワード"
                helperText={touched.password ? errors.password : ''}
                value={values.password}
                onChange={change.bind(null, 'password')}
                fullWidth
                required
              />
              <ButtonGrid>
                <Button onClick={props.handleCancel}>キャンセル</Button>
                <Button
                  color="primary"
                  disabled={toj(fields) === toj(values)}
                  onClick={(_e) => handleSubmit()}
                >
                  作成する
                </Button>
              </ButtonGrid>
            </form>
          )
        }}
      />
    </div>
  )
}

const CreateUserFormContainer = () => {
  const dispatch = useDispatch()

  return (
    <CreateUserForm
      handleSubmit={(...props) => dispatch(createUser(...props))}
      handleCancel={() => dispatch(createUserEnd())}
    />
  )
}

export default CreateUserFormContainer
